const DownloadApkModule = () => import(/* webpackChunkName: "download-apk-module" */ './views/module.vue')
const DownloadApk = () => import(/* webpackChunkName: "download-apk" */ './views/DownloadApk.vue')

const DownloadApkRoutes = {
    path: '/',
    component: DownloadApkModule,
    children: [
        {
            path: 'downloadapk',
            name: 'downloadapk',
            component: DownloadApk
        }
    ],
}

export default DownloadApkRoutes;